import { useState, useEffect } from 'react'

import { getVariant, getFlagPayload } from '@lib/analytics/amplitude/plugins/features/core'
import { FeatureFlagKey } from '@lib/analytics/amplitude/plugins/features/featureFlags'

export interface UseFeatureResult {
  value: string
  payload: Record<string, any> | null
  isLoading: boolean
  error: Error | null
}

export const useFeatureFlag = (flagKey: FeatureFlagKey): UseFeatureResult => {
  const [state, setState] = useState<UseFeatureResult>({
    value: '',
    payload: null,
    isLoading: true,
    error: null,
  })

  useEffect(() => {
    const loadExperiment = async () => {
      try {
        setState(prev => ({ ...prev, isLoading: true, error: null }))

        const variant = getVariant(flagKey)
        const payload = getFlagPayload(flagKey)

        setState({
          value: variant.value,
          payload,
          isLoading: false,
          error: null,
        })
      } catch (error) {
        setState(prev => ({
          ...prev,
          isLoading: false,
          error: error as Error,
        }))
      }
    }

    loadExperiment()
  }, [flagKey])

  return state
}
